import { CommonHelper } from 'src/utils/commonHelper';
import { LocalStorage } from 'src/utils/storage/local-storage';
import { SessionStorage } from 'src/utils/storage/session-storage';

const InitialSetup = (data, i18n) => {
  let isSetupDone = false;
  if (data.org_id) {
    if (true) {
      if (data.is_user_enabled) {
        data.brand_details = data.brand_details.filter((a) => a.is_enabled);
        if (data.brand_details?.length > 0) {
          let currentBrandId = CommonHelper.GetCurrentBrandId();
          if (currentBrandId) {
            let isBrandAvailable = data.brand_details?.some((a) => a.brand_id === currentBrandId);
            if (!isBrandAvailable) {
              sessionStorage.clear();
              SessionStorage.setItem('current_brand_id', JSON.stringify(data.brand_details[0].brand_id));
              // i18n.changeLanguage(data?.brand_details[0].language ? data?.brand_details[0].language : 'english');
              // localStorage.setItem('selectedLanguage', data?.brand_details[0].language ? data?.brand_details[0].language : 'english');
            }
            let brand_details = data.brand_details.find((a) => a.brand_id === currentBrandId);
            if (brand_details) {
              // i18n.changeLanguage(brand_details.language);
              // localStorage.setItem('selectedLanguage', brand_details.language);
            }
            isSetupDone = true;
          } else {
            sessionStorage.clear();
            SessionStorage.setItem('current_brand_id', JSON.stringify(data.brand_details[0].brand_id));
            // i18n.changeLanguage(data?.brand_details[0].language ? data?.brand_details[0].language : 'english');
            // localStorage.setItem('selectedLanguage', data?.brand_details[0].language ? data?.brand_details[0].language : 'english');
            isSetupDone = true;
          }
        } else {
          // i18n.changeLanguage(data?.language ? data?.language : 'english');
          // localStorage.setItem('selectedLanguage', data?.language ? data?.language : 'english');
          sessionStorage.clear();
        }
      }
    }
  }
  LocalStorage.setItem('initial-load', JSON.stringify(data));
  return isSetupDone;
};
export default InitialSetup;
